<template>
  <div class="panel">
    <!-- 基本工资 -->
    <div class="divider">{{ $t('424') }}</div>
    <!-- 月结 -->
    <template v-if="staffInfo.settlement_type == 1">
      <!-- 调薪前 -->
      <div v-for="(item, index) in staffInfo.salary.last" :key="index">
        <p class="title">{{ item.name }}</p>
        <el-form-item
          v-for="(element, num) in item.list"
          :label="element.name"
          :prop="'salary.last.' + index + '.list.' + num + '.val'"
          :rules="element.rule || {}"
          :key="num"
        >
          <el-input
            :disabled="show"
            v-model="element.val"
            v-enterNumberPoint2
            v-enterNumberMax="1000000000"
            placeholder="0.00"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 调薪后 -->
      <template v-if="staffInfo.is_salary_update == '1'">
        <el-form-item :label="$t('437')" prop="salary_update_start_date">
          <el-date-picker
            :disabled="show"
            v-model="staffInfo.salary_update_start_date"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('839')"
          >
          </el-date-picker>
        </el-form-item>
        <div v-for="(item, index) in staffInfo.salary.later" :key="index + item.name">
          <el-form-item :label="item.name" class="title"></el-form-item>
          <el-form-item
            v-for="(element, num) in item.list"
            :label="element.name"
            :prop="'salary.later.' + index + '.list.' + num + '.val'"
            :rules="element.rule || {}"
            :key="num + element.name"
          >
            <el-input
              v-model="element.val"
              v-enterNumberPoint2
              v-enterNumberMax="1000000000"
              placeholder="0.00"
              :disabled="show"
            ></el-input>
          </el-form-item>
        </div>
      </template>
    </template>
    <!-- 日结 -->
    <template v-if="staffInfo.settlement_type == '2'">
      <div v-for="(item, index) in staffInfo.salary" :key="index">
        <el-form-item :label="item.name" class="title"></el-form-item>
        <el-form-item
          v-for="(element, num) in item.list"
          :label="element.name"
          :prop="'salary.' + index + '.list.' + num + '.val'"
          :rules="element.rule || {}"
          :key="num"
        >
          <el-input
            v-model="element.val"
            v-enterNumberPoint2
            v-enterNumberMax="1000000000"
            placeholder="0.00"
            :disabled="show"
          ></el-input>
        </el-form-item>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxNum: 1000000000
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.title {
  display: block;
  font-size: 14px;
  color: #595959;
}
.panel {
  overflow: hidden;
}
.log {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
  text-decoration: underline;
}
.log-container {
  max-height: 400px;
  overflow: auto;
  ul {
    padding-left: 30px;
    li {
      margin-bottom: 5px;
    }
  }
  .log-title {
    margin-bottom: 10px;
    font-weight: bolder;
  }
  .log-content {
    padding-left: 20px;
  }
}
.divider {
  color: #262626;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
}
.el-form-item.title {
  margin-bottom: 0px;
  height: 45px;
}
</style>
